import { Children, cloneElement, ReactElement } from 'react';

import { isFunction } from '.';

function seizeAndForwardChildrenEvent(children: ReactElement | ReactElement[], eventName: string, event: Function): ReactElement[] {
  return Children.map(children, (child) => {
    const originalEvent = child.props[eventName];

    const newEvent = (...args: any[]): void => {
      if (isFunction(event)) {
        event(...args);
      }

      if (isFunction(originalEvent)) {
        originalEvent(...args);
      }
    };

    return cloneElement(child, { [eventName]: newEvent });
  });

}

export default seizeAndForwardChildrenEvent;
